import { render } from "./Assignments.vue?vue&type=template&id=be6cdf26&scoped=true"
import script from "./Assignments.vue?vue&type=script&lang=js"
export * from "./Assignments.vue?vue&type=script&lang=js"

import "./Assignments.vue?vue&type=style&index=0&id=be6cdf26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be6cdf26"]])

export default __exports__